export const COMPANY_FACEBOOK_PAGE = 'https://www.facebook.com/insiderfinance.io';
export const COMPANY_TWITTER = 'https://twitter.com/InsiderFinancex';
// Render these through components/EmailLink, which keeps them out of the server HTML.
export const COMPANY_EMAIL = 'team@insiderfinance.io';
export const SALES_EMAIL = 'sales@insiderfinance.io';
export const COMPANY_INSTAGRAM = 'https://www.instagram.com/insiderfinance.io';
export const COMPANY_LINKEDIN = 'https://www.linkedin.com/company/insiderfinance';
export const APPLE_APP_STORE_LINK = 'https://apps.apple.com/us/app/insiderfinance/id6444453657';
export const GOOGLE_PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=com.insiderfinance.dashboard&pcampaignid=web_share';
